export function enforceExhaustive(v: never): never {
  throw new Error("Unexpected value: " + v);
}
